import { css } from 'styled-components';

export const BtnMixin = css`
  width: 100%;
`;
